/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sci_plot_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to save your datasets`)
};

const es_sci_plot_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para guardar tus datos`)
};

const de_sci_plot_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich an, um deine Datensätze zu speichern`)
};

const nl_sci_plot_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld je aan om je datasets op te slaan`)
};

const fr_sci_plot_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour enregistrer vos données`)
};

const it_sci_plot_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per salvare i tuoi dataset`)
};

const pt_br2_sci_plot_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para salvar seus dados`)
};

const pt_sci_plot_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sessão para guardar os teus dados`)
};

const ja_sci_plot_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインインしてデータセットを保存`)
};

const zh_sci_plot_signin_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录以保存你的数据集`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sci_plot_signin_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sci_plot_signin_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sci_plot_signin_hint", locale)
	if (locale === "en") return en_sci_plot_signin_hint(inputs)
	if (locale === "es") return es_sci_plot_signin_hint(inputs)
	if (locale === "de") return de_sci_plot_signin_hint(inputs)
	if (locale === "nl") return nl_sci_plot_signin_hint(inputs)
	if (locale === "fr") return fr_sci_plot_signin_hint(inputs)
	if (locale === "it") return it_sci_plot_signin_hint(inputs)
	if (locale === "pt-BR") return pt_br2_sci_plot_signin_hint(inputs)
	if (locale === "pt") return pt_sci_plot_signin_hint(inputs)
	if (locale === "ja") return ja_sci_plot_signin_hint(inputs)
	return zh_sci_plot_signin_hint(inputs)
};